import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProfileScoring.css';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';

import CandidateOverview from '../../../components/Client/CandidateOverview/CandidateOverview';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../../services/axios-service';
import ScoreRadio from '../../../components/UI/RadioButton/RadioButton';
import ProfileModal from '../../../components/Client/ProfileModal/ProfileModal';
import * as actions from '../../../store/actions/index';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import { scoringCriteria } from '../../../shared/constants';

const scoreMax = 5;

/**
* @desc radio button for adding score
* @param props
* @return score depending on the condition checked or unchecked
*/
const Score = (props) => {
  return (
    <div className="score-item">
      <div className="name">{props.name}</div>
      <div className="score">
        {[...Array(scoreMax)].map((score, index) => (
          <div className="option" key={index}>
            <div className="value">{index+1}</div>
            <ScoreRadio 
              index={index+1} 
              id={props.id} 
              value={props.value} 
              handleScoreChange={props.handleScoreChange} 
              radioDisable={props.radioDisable}
            />
            <div className="check-score"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

/**
* @desc Actual scoring part 
* @param props
* @return whole scoring part
*/
const Scoring = (props) => {
  return (
    <div className="scoring">
    {props.scoring.map((score, index) => (      
      <Score 
        key={index} 
        {...score} 
        handleScoreChange={props.handleScoreChange} 
        radioDisable={props.radioDisable}
      />
    ))}
    </div>
  );
}

/**
* @desc checks whether Scoring is added to all values
* @param scoring array
* @return true or false
*/
const isScoringComplete = (scoring) => {
  const complete = scoring.find((score) => score.value == 0);
  if (complete === undefined) {
    return true;
  } else {
    return false;
  }
}

/**
* @desc Adds the scoring value
* @param scoring array
* @return total scoring value
*/
const addTotal = (scoring) => {
  const total = scoring.reduce((sum, score) => sum + score.value, 0);
  return total;
}

/**
* @desc handling and viewing score of  particular candidate and can manage the interview.
* @version
* @author Jamshith 
*/
class ProfileScoring extends Component {
  constructor(props, context) {
    super(props, context);
    const jobType = (props.profileInfo.scoringCriteriaType && props.profileInfo.scoringCriteriaType !== "" ) ? props.profileInfo.scoringCriteriaType : 'default';
    this.state = {
      ScoringData: scoringCriteria[jobType].scoringData,
      scoringCuttoff: scoringCriteria[jobType].scoringCuttoff,
      scoring: [],
      total: 0,
      scoringComplete: false,
      scoringSent: false,
      scored_by:"",
      showScoredWarningModal:false,
      showCompleteWarning: false,
      confirmButtonText: 'Confirm Scoring',      
      showModal:"",
      status:"",
      candidateId:"",
      regretReason:1,
      candidate_status:"",
      lastScored:false,
      
    };
    this.handleScoreChange = this.handleScoreChange.bind(this);
    this.handleCompleteWarningClose = this.handleCompleteWarningClose.bind(this);
    this.handleScoredWarningClose = this.handleScoredWarningClose.bind(this);
    this.handleCompleteWarningOpen = this.handleCompleteWarningOpen.bind(this);
    this.handleCompleted = this.handleCompleted.bind(this);
    this.handleNotCompleted = this.handleNotCompleted.bind(this);

    this.progressCount = 0;
  }

  /**
  * @desc Initialize the component - displays the scores according to the api response
  * @param null
  * @return null
  */
  componentDidMount() {
    const scoringDataJson = [...this.state.ScoringData];
    const scoring = [...scoringDataJson];
    const confirmButtonText = 'Confirm Scoring';
    this.setState({ scoring:scoring, 
                    total: addTotal(scoring),
                    confirmButtonText:confirmButtonText,
                    scoringSent: false,
                    scoringComplete:false,
                   });
    
    if(this.props.profileInfo.candidate_id){
      this.setState({candidate_status:this.props.profileInfo.candidate_status});
    }
  }

  /**
  * @desc updates the candidate status as well as handling the progress/regret pop-up.
  * @param prevProps,prevState
  * @return null
  */
 componentWillUpdate(prevProps, prevState) { 
  const pool = [...prevProps.pool];
  if(pool.length > 0) {
   if(this.props.profileInfo.candidate_status !== prevProps.profileInfo.candidate_status || 
      this.state.candidate_status=="" || 
      this.props.profileInfo.candidate_id !== prevProps.profileInfo.candidate_id) {
      this.setState({ candidate_status: prevProps.profileInfo.candidate_status });
    }
  }
}



  /**
  * @desc updates the scores when changing the candidate and we changes the scores
  * @param prevProps,prevState
  * @return null 
  */
  componentDidUpdate(prevProps, prevState) {
    const scoringDataJson = [...this.state.ScoringData];

    if(JSON.parse(this.props.candidate.candidate_scoring) !== null && JSON.stringify(this.state.scoring) !== JSON.stringify(JSON.parse(this.props.candidate.candidate_scoring))) {
      const scoring = JSON.parse(this.props.candidate.candidate_scoring);
      const confirmButtonText = 'Completed';
      this.setState({ scoring:scoring, total: addTotal(scoring),confirmButtonText:confirmButtonText,scoringSent: true,scoringComplete:true});
    } else if(this.props.candidate.candidate_id !== prevProps.candidate.candidate_id) {
      const scoring = (JSON.parse(this.props.candidate.candidate_scoring) !== null) ? JSON.parse(this.props.candidate.candidate_scoring) : [...scoringDataJson];
      let confirmButtonText = 'Confirm Scoring', scoringSent = false, scoringComplete =false;
      if(this.props.candidate.candidate_score !== 0) {
        confirmButtonText = 'Completed';
        scoringSent = true;
        scoringComplete = true;
      }
      this.setState({ scoring:scoring, total: addTotal(scoring),confirmButtonText:confirmButtonText,scoringSent: scoringSent,scoringComplete:scoringComplete});
    }
  }

 /**
  * @desc  Updates the score of candidate 
  * @param event -passing on selecting status
  * @return returns null conditionally
  */
  handleScoreChange = (e) => {
    if(this.state.scoringSent) {
      return;
    }
    var value;
    if (e.hasOwnProperty('target')) {
      value = e.target.value
    } else {
      value = e;
    }
    const id = e.target.name;
    
    let scoring = [...this.state.scoring];
    let scoreDataObject = {...scoring.find((score) => score.id == id)};
    
    scoreDataObject.value = parseInt(value);
    let scoreIndex = scoring.findIndex((score) => score.id == id);
    scoring[scoreIndex] = scoreDataObject;
    const confirmButtonText = 'Confirm Scoring';
    this.setState({
      scoring:scoring,
      total: addTotal(scoring),
      scoringComplete: isScoringComplete(scoring),
      confirmButtonText:confirmButtonText
    });
  }

  /**
  * @desc opens warning pop-up for submiting the score data and sends to database
  * @param null
  * @return null
  */
  handleCompleteWarningOpen = () => {
    if(parseInt(this.state.total) > this.state.scoringCuttoff) {
      this.open("PROGRESS", this.props.profileInfo.candidate_id);
    } else {
      this.open("REGRET", this.props.profileInfo.candidate_id);
    }
  }

  /**
  * @desc closes warning pop-up for submiting the score data
  * @param null
  * @return null
  */
  handleCompleteWarningClose = () => {
    this.setState({ showCompleteWarning: false });
  }
  handleScoredWarningClose =()=>{
    this.props.onGetProfileDetails(this.props.activeCandidateId,this.props.jobTitleId ,true,this.props.user);
    this.props.onGetTalentPool(this.props.jobTitleId,this.props.user);
    const showModal = (this.state.lastScored) ? true : false;
    const status = (this.state.lastScored) ? "" : this.state.status;
    this.setState({ showScoredWarningModal: false, showModal: showModal, status: status });
  }
  /**
  * @desc conforming warning pop-up for submiting the score data
  * @param null
  * @return null
  */
  handleCompleted = (status) => {
    this.postScoring({
      candidateId:this.props.candidate.candidate_id,
      jobId:this.props.jobTitleId,
      scoreData:JSON.stringify(this.state.scoring),
      score:this.state.total,
      scoredBy: this.props.clientDetails.user_id,
    },status);
    const isShowToast =(status === 'REGRET'&& this.state.lastScored!==true)?true:false;
    const toastMessage= status === 'REGRET' ?'Candidate has been regretted':'';
    const toastVariant = status === 'REGRET'?'regret':'';
  
    this.setState({ showCompleteWarning: false, 
                    scoringSent: true, 
                    confirmButtonText: 'Completed',                    
                  });
                  this.props.handleRegret(isShowToast,toastMessage,toastVariant);
  }

  /**
  * @desc closes warning pop-up for submiting the score data
  * @param null
  * @return null
  */
  handleNotCompleted = () => {
    this.setState({ showCompleteWarning: false, 
                    scoringSent: false, 
                    confirmButtonText: this.state.confirmButtonText
                  });
  }
  

  /**
  * @desc posting scoringDetails to database
  * @param scoringDetails 
  * @return null
  */
  postScoring = (scoringDetails,status) => {
    axios.post("/galaxy/client/candidate-score",JSON.stringify(scoringDetails))
    .then((response)=>{     
        if(response.data.message==="Already Scored"){
          this.setState({
            scored_by:"",
            showScoredWarningModal:true,
            regretReason:1,
            status:"already"                 
          });
        }
        else if(response.data.message==="Score Updated") {
         status==="PROGRESS"? 
          this.props.onPoolStatusChange(
            this.props.profileInfo.candidate_id, 
            "PROGRESS",
            this.props.jobTitleId, 
            false, 
            '', 
            this.props.clientDetails.user_id,
            scoringDetails.scoreData, 
            scoringDetails.score,
            this.props.clientDetails.user_fname + " " + this.props.clientDetails.user_lname,
            this.state.candidate_status
          )
          :
          this.props.onPoolStatusChange(
            this.state.candidateId,
            "REGRET",
            this.props.jobTitleId, 
            false,
            this.state.regretReason, 
            this.props.clientDetails.user_id,
            scoringDetails.scoreData, 
            scoringDetails.score,
            this.props.clientDetails.user_fname + " " + this.props.clientDetails.user_lname,
            this.state.candidate_status
          );
          this.setState({
            candidate_status:status,
            scored_by:this.props.clientDetails.user_fname+" "+this.props.clientDetails.user_lname,
            regretReason:1,
            status:""
          });
          this.props.updateCandidateStatus(status);
          this.state.lastScored? this.setState({showModal:true}):"";
        }
        
    })
    .catch((error) => {
       ConsoleLog(error);
      throw error;
    });

  }

  /**
   * @desc open the model and decides which model should open according to the given condition.
   * @param status,candidateId
   * @return null
   */
  open = (status,candidateId) => {
    const pool = [...this.props.pool];
    const unsortedList = pool.find((candidate) => (candidate.candidate_status === "PENDING" && candidate.candidate_id !== candidateId));
    const lastScored = !unsortedList ? true :false;
    const progressed = localStorage.getItem('Progress');
    const progressCandidatesList = pool.filter(cand => cand.candidate_status === "PROGRESS" );
    let showModalStatus = true;
    let isShowToast=false;

    if(status === "PROGRESS" && (progressCandidatesList.length  > 0  || progressed) ) {
      showModalStatus = false;  
      isShowToast=true;
      this.handleCompleted("PROGRESS");
    }    
     else if(status=="PROGRESS" && (progressCandidatesList.length === 0 || !progressed )) {
      isShowToast:false;
       this.setState({ candidate_status:status,isShowToast:false });
      localStorage.setItem('Progress','true');
    }    
    const showToast= (status=== 'PROGRESS'&& progressed && lastScored!==true )?isShowToast:false;
    const toastMessage= status=== 'PROGRESS' ?'Candidate has been progressed':'';
    const toastVariant = status=== 'PROGRESS'?'progress':'';
      this.setState({ 
        showModal: showModalStatus, 
        status:status, 
        candidateId: candidateId,
        lastScored :lastScored,
      });
      this.props.handleProgress(showToast,toastMessage,toastVariant);
  }

  /**
  * @desc closes the model
  * @param null
  * @return null
  */
  close = () => {
    this.setState({ showModal: false, status:"" });  
    this.handleCompleted("PROGRESS");
  }

  /**
  * @desc changes the regretReason
  * @param event
  * @return null
  */
  handleChange = (event) => {
    this.setState({ regretReason: event.target.value });    
  }

  /**
  * @desc updates the candidate status to the database
  * @param candidate status
  * @return null
  */
  updateCandidateStatus = (status) => {
    this.setState({ showModal: false ,status:"" });   
    this.handleCompleted("REGRET");
  }

  /**
  * @desc rendering the html
  * @param null
  * @return the DOM element for this component
  */
  render() {
    const candidate = this.props.profileInfo;
    const confirmButtonDisabled = (this.state.scoringComplete && !this.state.scoringSent) ? false : true;
    const radioButtonDisabled = (this.state.scoringSent ) ? 'disabled' : '';

    return (
      <div className="profile-scoring">
        <ProfileModal 
          status= {this.state.status} 
          showModal={this.state.showModal} 
          candidateStatus={this.candidateStatus} 
          progressCount={this.progressCount} 
          close={this.close} 
          updateCandidateStatus={()=>this.updateCandidateStatus("REGRET")} 
          handleChange={this.handleChange}
        />
        <div className="profile">
        <CandidateOverview 
          {...this.props} 
          candidate={candidate} 
          candidate_id={candidate.candidate_id} 
          candidate_status={this.state.candidate_status} 
          onPoolStatusChange={this.props.onPoolStatusChange}
          open={this.props.open}
          isCandidateScoring={true}
          candidatePhoto={this.props.candidatePhoto}
          isS3Url={this.props.isS3Url}
        />
        </div>
        <div className="scoring-top-line visible-xs-block"></div>
        <h1 className="profile-scoring-title visible-xs-block">Interview Scoring</h1>
        <div className="profile-scoring-title hidden-xs">
          <h1>Interview Scoring</h1>
          <div className="value">1</div>
          <div className="value">2</div>
          <div className="value">3</div>
          <div className="value">4</div>
          <div className="value">5</div>
        </div>

        <Scoring 
          scoring={this.state.scoring} 
          handleScoreChange={this.handleScoreChange} 
          radioDisable={radioButtonDisabled} 
        />
        <div className="scoring-bottom-line"></div>
        <div className="scoring-total">
          <span className="score-icon">
            {(this.state.scoringComplete && !this.state.scoringSent) ? 
              ((this.state.total > this.state.scoringCuttoff) ? 
                <div className="progress-icon"></div> 
              : <div className="regret-icon"></div>) 
            : null}
          </span>
          Total: <span>{this.state.total}</span>
        </div>
        <div className="scoring-buttons">
          {(this.state.confirmButtonText === "Completed"?
            <span className="client-candidate-scored-by">
              Completed by:&nbsp;<p className="candidate-completed-name">{this.props.profileInfo.scored_by!==""?this.props.profileInfo.scored_by:this.state.scored_by}</p>
              </span> :
            "")
          }
          <Button 
            className={this.state.confirmButtonText === "Completed" ? 'btn-completed' : 'btn-confirm'} 
            bsStyle="warning" 
            onClick={this.handleCompleteWarningOpen} 
            disabled={confirmButtonDisabled}
          >{this.state.confirmButtonText}</Button>
        </div>

        <Modal 
          className="scoring-modal" 
          show={this.state.showCompleteWarning} 
          onHide={this.handleCompleteWarningClose} 
        >
          <Modal.Header onClick={this.handleNotCompleted}closeButton></Modal.Header>
          <Modal.Body>
            <h1>Thank you!</h1>
            <p>Your feedback helps to advance the hiring decisions.<br /><br />Please ensure you have reviewed all the candidates for this roll and send to the Recruiter from your Talent Pool.</p>
            <Button  onClick={this.handleCompleted}>Continue</Button>
          </Modal.Body>
        </Modal>

        <Modal 
          className="scored-warning-modal" 
          show={this.state.showScoredWarningModal} 
        >
          <Modal.Body>
            <p className="scored-alert">Candidate Already Scored By Someone Else!<br/>Click Ok to show the latest changes</p>
            <Button  onClick={this.handleScoredWarningClose}>OK</Button>
          </Modal.Body>
        </Modal>

        
      </div>
    );
  }
}

/**
* @desc connecting to the redux store
* @param null
* @return redux state
*/
const mapStateToProps = state => {
  return {
    user: state.cognito.user,
    attributes: state.cognito.attributes,
    activeCandidateId: state.talentPool.activeCandidateId,
    profileInfo: state.candidateProfile.profileInfo,
    pool: state.talentPool.pool,
    clientDetails: state.clientProfile.clientDetails,
    jobTitleId: state.talentPool.jobTitleId
  };
}

/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
  return {
    onPoolStatusChange: (canidateId, status,jobId, isReviewAll,regretReason, scoredBy, score,totalScore,scoredByName,prevStatus) => dispatch(actions.handlePoolStatusChange(canidateId, status,jobId, isReviewAll,regretReason, scoredBy, score, totalScore,scoredByName,prevStatus)),
    onGetProfileDetails: (canidateId, jobTitleId,isClient,user) => dispatch(actions.getProfileDetails(canidateId, jobTitleId,isClient,user)),
    onGetTalentPool: (jobTitleId,user) => dispatch(actions.getTalentPool(jobTitleId,user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ProfileScoring, axios));



// WEBPACK FOOTER //
// ./src/container/Client/ProfileScoring/ProfileScoring.js